import React, { Fragment, useState } from 'react';
import { List, ListItem, Collapse } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.css';

const MobileMenu = () => {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
    setMenuState(false);
  };

  const menus = [
    {
      id: 1,
      title: t('home'),
      link: '/home',
    },
    {
      id: 2,
      title: t('about'),
      link: '/about',
    },
    {
      id: 3,
      title: t('service'),
      submenu: [
        { id: 31, title: t('consulting_services'), link: '/service-single/consulting-services' },
        { id: 32, title: t('international_trading'), link: '/service-single/international-trading' },
        { id: 33, title: t('transportation_logistics'), link: '/service-single/transportation-logistics' },
      ],
    },
    {
      id: 4,
      title: t('products'),
      submenu: [
        { id: 41, title: t('mining_equipments'), link: '/products/Mining%20Equipment' },
        { id: 42, title: t('drilling_bits'), link: '/products/Drilling%20Bit' },
        { id: 43, title: t('heavy_tires'), link: '/products/Heavy%20Tires' },
      ],
    },
    {
      id: 5,
      title: t('contact'),
      link: '/contact',
    },
  ];

  return (
    <div>
      {/* Mobile Drawer */}
      <div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(false)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item) => (
            <ListItem key={item.id} className={item.id === openId ? 'active' : null}>
              {item.submenu ? (
                <Fragment>
                  <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                    {item.title}
                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                  </p>
                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                        <List className="subMenu" component="div">

                      {item.submenu.map((submenu) => (
                        <ListItem key={submenu.id}>
                          <NavLink
                            onClick={ClickHandler}
                            to={submenu.link}
                            className={({ isActive }) => (isActive ? 'active' : '')}
                          >
                            {submenu.title}
                          </NavLink>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <NavLink
                  onClick={ClickHandler}
                  to={item.link}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {item.title}
                </NavLink>
              )}
            </ListItem>
          ))}
        </ul>
        <div>
            <h3 style={{marginTop:'450px', marginLeft:'20px'}}>OPTIMIZE INC LLC</h3>
        </div>
      </div>

      {/* Toggle Button */}
      <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>


    </div>
    
  );
};

export default MobileMenu;
